/** 避免 commonApi ↔ deviceSessionPresence 循环依赖 */
let standbyMode = false;

declare global {
  interface Window {
    __eweadn_deviceSessionStandby?: boolean;
  }
}

export function setDeviceSessionStandbyMode(active: boolean): void {
  standbyMode = active;
  if (typeof window !== "undefined") {
    window.__eweadn_deviceSessionStandby = active;
    window.dispatchEvent(
      new CustomEvent("eweadn:deviceSessionStandbyChanged", {
        detail: { standby: active },
      })
    );
  }
}

export function isDeviceSessionStandbyMode(): boolean {
  if (typeof window !== "undefined" && window.__eweadn_deviceSessionStandby) {
    return true;
  }
  return standbyMode;
}
